import { render, staticRenderFns } from "./RestrictedKeywordsInfo.vue?vue&type=template&id=e45f5f28&scoped=true"
import script from "./RestrictedKeywordsInfo.vue?vue&type=script&lang=js"
export * from "./RestrictedKeywordsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e45f5f28",
  null
  
)

export default component.exports